<div *ngIf="viewModel" class="row">
    <div class="col-md-6">
        <div class="widget right-ear h-100">
            <div class="row justify-content-center mb-2">
                <div class="col-md-2">
                    <div class="title">
                        {{'Screens.Patients.InfoWidget.NoahSession.RightEar' | translate}}
                    </div>
                </div>
            </div>
            <div class="row">                
                <div class="col-md-12">
                    <div>
                        <noah-graph *ngIf="viewModel?.rightGraph" [graphModel]="viewModel.rightGraph"
                            [side]="rightSideEnumValue"></noah-graph>
                        <div *ngIf="!viewModel?.rightGraph" class="no-data-message">
                            {{'Screens.Patients.InfoWidget.NoahSession.NoDataMessage' | translate}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="viewModel?.rightGraph"> 
                <div class="col-md-12">
                    <noah-values [graphModel]="viewModel.rightGraph"></noah-values>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="widget left-ear h-100">
            <div class="row justify-content-center mb-2">
                <div class="col-md-2">
                    <div class="title">
                        {{'Screens.Patients.InfoWidget.NoahSession.LeftEar' | translate}}
                    </div>
                </div>
            </div>
            <div class="row">                
                <div class="col-md-12">
                    <div>
                        <noah-graph *ngIf="viewModel?.leftGraph" [graphModel]="viewModel.leftGraph"
                            [side]="leftSideEnumValue"></noah-graph>
                        <div *ngIf="!viewModel?.leftGraph" class="no-data-message">
                            {{'Screens.Patients.InfoWidget.NoahSession.NoDataMessage' | translate}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="viewModel?.leftGraph"> 
                <div class="col-md-12">
                    <noah-values [graphModel]="viewModel.leftGraph"></noah-values>
                </div>
            </div>
        </div>
    </div>
</div>